import "./polyfills"; // Import polyfills first
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App.tsx";
import "./i18n/i18n";
import store from "./store/store.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { registerSW } from "virtual:pwa-register";
import "./sentry.ts";
import { preloadAllFonts } from "./components/canvas/helpers/fontHelpers";

// Register service worker for PWA support with proper update handling
registerSW({
  immediate: false, // Don't activate immediately
  onNeedRefresh() {
    // Use Sonner toast to show a user-friendly update notification
    console.log("[SW] New content available. Please refresh when ready.");
  },
  onOfflineReady() {
    console.log("[SW] Offline ready");
  },
  onRegistered(registration) {
    // When the service worker is registered, ensure it doesn't force updates
    if (registration) {
      // Check for updates periodically
      setInterval(() => {
        registration.update().catch(console.error);
      }, 60 * 60 * 1000); // Check for updates every hour
    }
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: true,
      retryOnMount: true,
      retry: false,
    },
  },
});

// Preload Google Fonts for Fabric.js canvas
preloadAllFonts().catch((error) => {
  console.warn("Failed to preload some fonts:", error);
});

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Toaster richColors />
      <App />
    </QueryClientProvider>
  </Provider>
);
